// 404 Not Found page.
//
// Shown for any URL that does not match a known route. Previously, unmatched
// routes (e.g. /portal/orders-inbox, /portal/dashboard, or any typo) rendered
// a blank page with no redirect because there was no catch-all route. The
// catch-all in App.tsx now renders this page:
//   - Unauthenticated users never see it: the top-level catch-all wraps it in
//     ProtectedRoute, which redirects them to /login (returnUrl preserved),
//     and the /portal catch-all is gated by the portal's parent ProtectedRoute.
//   - Authenticated users get this friendly "page doesn't exist" surface
//     instead of a blank screen.

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div
      role="main"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
        color: '#1f2937',
      }}
    >
      <p style={{ fontSize: '3.5rem', fontWeight: 700, color: '#0B4FA3', margin: 0, lineHeight: 1 }}>
        404
      </p>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '0.75rem 0 0.25rem' }}>
        Page not found
      </h1>
      <p style={{ color: '#6b7280', maxWidth: 420, margin: '0 0 1.5rem' }}>
        The page you’re looking for doesn’t exist or may have moved.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '0.5rem 1.25rem',
          background: '#0B4FA3',
          color: '#ffffff',
          borderRadius: 6,
          textDecoration: 'none',
          fontWeight: 500,
        }}
      >
        Go to home
      </Link>
    </div>
  );
}
